import { FormGroup } from '@angular/forms';
import { DateControl } from '../services/leg-date.service';
import {
  CalculateFutureDatePayload,
  Leg,
  RfqLegSettings
} from '@approot/models';
import { markFieldAsPending, removePendingFromField } from './leg.utilities';

export function calculateFutureDateMarkPending(
  form: FormGroup,
  leg: Leg,
  primaryFormControl: DateControl,
  secondaryFormControl: DateControl,
  payload: CalculateFutureDatePayload
): void {
  if (primaryFormControl?.setFormControl) {
    markFieldAsPending(form, leg, primaryFormControl.controlName);
  }

  if (secondaryFormControl?.setFormControl) {
    markFieldAsPending(form, leg, secondaryFormControl.controlName);
  }

  if (
    payload.task === 'getDcdRedemptionDateAndTreasuryRate' ||
    payload.task === 'getDcdExpirationDateAndTreasuryRate'
  ) {
    // used if we are using a newdcd
    // just shows certain spinners
    markFieldAsPending(form, leg, 'treasuryRate');
    if (
      payload.task === 'getDcdExpirationDateAndTreasuryRate' &&
      !form.get('expiryDate').valid
    ) {
      markFieldAsPending(form, leg, 'expiryDate');
    } else if (!form.get('redemptionDate').valid) {
      markFieldAsPending(form, leg, 'redemptionDate');
    }
  }
}

export function handleCalculateFutureDateForRate(
  payload: CalculateFutureDatePayload,
  form: FormGroup,
  leg: Leg,
  rfqExecutionSettings: RfqLegSettings
): void {
  if (
    payload.task === 'getDcdRedemptionDateAndTreasuryRate' ||
    payload.task === 'getDcdExpirationDateAndTreasuryRate'
  ) {
    // if using a dcd hide spinners
    payload.dateOrLag =
      payload.task === 'getDcdRedemptionDateAndTreasuryRate'
        ? payload.product.expiryDate
        : payload.product.redemptionDate;
    removePendingFromField(form, leg, rfqExecutionSettings, 'treasuryRate');
    if (
      payload.task === 'getDcdExpirationDateAndTreasuryRate' &&
      !form.get('expiryDate').valid
    ) {
      removePendingFromField(form, leg, rfqExecutionSettings, 'expiryDate');
    } else if (!form.get('redemptionDate').valid) {
      removePendingFromField(form, leg, rfqExecutionSettings, 'redemptionDate');
    }
  }
}
